// ** Component Imports
import { Button, Typography } from '@/shared/ui'

// ** Utility Imports
import { useAppSelector } from '@/shared/lib'

export const SUBSCRIPTION_PAGE_PATH = '/subscription-plan'

/**
 * "Upgrade" → the subscription page. Only the organization owner can subscribe
 * (the page is owner-only), so members are told who to ask instead.
 */
export const FreePlanUpgradeButton = () => {
	const { user: currentUser } = useAppSelector((state) => state.currentUser)

	if (currentUser?.role?.name !== 'Owner') {
		return (
			<Typography variant='body2' weight='medium'>
				Ask your organization owner to upgrade.
			</Typography>
		)
	}

	return (
		<Button
			label='Upgrade'
			variant='primary'
			size='small'
			to={SUBSCRIPTION_PAGE_PATH}
		/>
	)
}
